import TextReportGenerator from "../TextReportGenerator";
import ReportData from "../../ReportData";
import { saveClassByClassNameDecorator } from "../../../../shared/utils/classNameToConstructor";
import { DisplayedField } from "../../DisplayedField";

const DEFAULT_VERSION = "1";

const TITLE: string = "ClearVoyage Arrival Report";

const FIELDS: DisplayedField[] = [
  { fieldType: "IMONumber", required: true },
  { fieldType: "ReportDate", required: true },
  { fieldType: "Remarks", required: false },
  { fieldType: "ConsumptionItemsSOSP", required: true },
  { fieldType: "ROBItems", required: true },
  { fieldType: "ArrivalPort", required: true },
  { fieldType: "Position", required: true },
  { fieldType: "LoadCondition", required: true },
  { fieldType: "NextCondition", required: false },
  { fieldType: "DraftMid", required: true },
  { fieldType: "DraftFore", required: true },
  { fieldType: "DraftAft", required: true },
  { fieldType: "Anchorage", required: false },
];

@saveClassByClassNameDecorator()
class ClearVoyageArrivalReportGenerator extends TextReportGenerator {
  public constructor() {
    super(TITLE, FIELDS, DEFAULT_VERSION);
  }

  getReportText(_data: ReportData, _version: string | undefined): string {
    return "";
  }
}

export default ClearVoyageArrivalReportGenerator;
